import { escolaInfoResponseSchema, type EscolaInfoResponse } from '@/features/benchmarking/schemas/benchmarkingInfo';
import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';
import { httpPutAdapter } from '@/lib/adapters/httpPutAdapter';

export type GetBenchmarkingInfoParams = { escolaId: number };

export const getBenchmarkingInfo = httpGetAdapter<EscolaInfoResponse, GetBenchmarkingInfoParams>({
  url: (params) => `/v3/microdados/escola/${params.escolaId}/info`,
  schema: escolaInfoResponseSchema,
});

export type SaveSchoolGoalParams = { escolaId: number; metaEscola: number };

export const saveSchoolGoal = httpPutAdapter<void, SaveSchoolGoalParams>({
  url: (params) => `/v3/microdados/escola/${params.escolaId}/meta`,
  mapBody: ({ metaEscola }) => ({ metaEscola }),
});
